(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fWbcT", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf; }, function (v) { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b9a4f744ab95abc4$export$f7ad0328861e2f03; }, function (v) { return $b9a4f744ab95abc4$export$f7ad0328861e2f03 = v; });
var $b9a4f744ab95abc4$export$6503ec6e8aabbaf;
var $b9a4f744ab95abc4$export$f7ad0328861e2f03;
"use strict";
var $b9a4f744ab95abc4$var$mapping = new Map();
function $b9a4f744ab95abc4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b9a4f744ab95abc4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b9a4f744ab95abc4$var$resolve(id) {
    var resolved = $b9a4f744ab95abc4$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b9a4f744ab95abc4$export$6503ec6e8aabbaf = $b9a4f744ab95abc4$var$register;
$b9a4f744ab95abc4$export$f7ad0328861e2f03 = $b9a4f744ab95abc4$var$resolve;

});

parcelRegister("dOGL2", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a0f11cae5038e8ee$export$bdfd709ae4826697; }, function (v) { return $a0f11cae5038e8ee$export$bdfd709ae4826697 = v; });
var $a0f11cae5038e8ee$export$bdfd709ae4826697;
var $a0f11cae5038e8ee$export$c9e73fbda7da57b6;
var $a0f11cae5038e8ee$export$5a759dc7a1cfb72a;
"use strict";
var $a0f11cae5038e8ee$var$bundleURL = {};
function $a0f11cae5038e8ee$var$getBundleURLCached(id) {
    var value = $a0f11cae5038e8ee$var$bundleURL[id];
    if (!value) {
        value = $a0f11cae5038e8ee$var$getBundleURL();
        $a0f11cae5038e8ee$var$bundleURL[id] = value;
    }
    return value;
}
function $a0f11cae5038e8ee$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a0f11cae5038e8ee$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a0f11cae5038e8ee$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a0f11cae5038e8ee$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a0f11cae5038e8ee$export$bdfd709ae4826697 = $a0f11cae5038e8ee$var$getBundleURLCached;
$a0f11cae5038e8ee$export$c9e73fbda7da57b6 = $a0f11cae5038e8ee$var$getBaseURL;
$a0f11cae5038e8ee$export$5a759dc7a1cfb72a = $a0f11cae5038e8ee$var$getOrigin;

});

parcelRegister("8JF4K", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("3Njl8")).then(function() {
    return parcelRequire("jIOBL");
});

});
parcelRegister("gZJRp", function(module, exports) {
"use strict";

var $bzWhm = parcelRequire("bzWhm");
module.exports = $bzWhm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("bzWhm", function(module, exports) {
"use strict";
var $86e02b94fb59de77$var$cachedBundles = {};
var $86e02b94fb59de77$var$cachedPreloads = {};
var $86e02b94fb59de77$var$cachedPrefetches = {};
function $86e02b94fb59de77$var$getCache(type) {
    switch(type){
        case "preload":
            return $86e02b94fb59de77$var$cachedPreloads;
        case "prefetch":
            return $86e02b94fb59de77$var$cachedPrefetches;
        default:
            return $86e02b94fb59de77$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $86e02b94fb59de77$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("lijxe", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("6TWkf"))
]).then(function() {
    return parcelRequire("5SZvv");
});

});

parcelRegister("5uX6c", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("474Cq"))
]).then(function() {
    return parcelRequire("9bTKq");
});

});

parcelRegister("8m52L", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("gKbjC"))
]).then(function() {
    return parcelRequire("kQCit");
});

});

parcelRegister("IJ08D", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("iFwFa")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("5plI9"))
]).then(function() {
    return parcelRequire("dBisn");
});

});

parcelRegister("bvWYn", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("1jN2E"))
]).then(function() {
    return parcelRequire("briE9");
});

});

parcelRegister("bBnUP", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("atd31"))
]).then(function() {
    return parcelRequire("9cOtQ");
});

});

parcelRegister("lyXDL", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("dCbO2"))
]).then(function() {
    return parcelRequire("d0vrx");
});

});

parcelRegister("lX62M", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("Hw6F8")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("k2CPQ"))
]).then(function() {
    return parcelRequire("3N7qb");
});

});

parcelRegister("kUVQA", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("Hw6F8")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("aVFCZ"))
]).then(function() {
    return parcelRequire("70FF6");
});

});

parcelRegister("gPrLj", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("Hw6F8")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("3TmCC"))
]).then(function() {
    return parcelRequire("9U6M2");
});

});

parcelRegister("2T9xQ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("Hw6F8")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("bnNTo"))
]).then(function() {
    return parcelRequire("agVFL");
});

});

parcelRegister("dn7Fz", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("b3tdi")).then(function() {
    return parcelRequire("hgTie");
});

});

parcelRegister("dpdnY", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("iFwFa")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("3Njl8")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("dbWMA"))
]).then(function() {
    return parcelRequire("764W2");
});

});

var $b93b4d2a3099312b$exports = {};


(parcelRequire("fWbcT")).register((parcelRequire("dOGL2")).getBundleURL("2iNWU"), JSON.parse('["2iNWU","as-legacy.js","3Njl8","ccm19.module.dbd285a3.js","6TWkf","flyout.module.ab4c1996.js","kcLCU","flyout.module.2dedc263.js","474Cq","header.module.f0d837eb.js","gKbjC","magnificPopup.module.1c69ec0a.js","5plI9","modal.module.ed8983de.js","iFwFa","modal.module.0efb55f5.js","1jN2E","panel.module.656222bd.js","atd31","stickyButton.module.51ed603d.js","dCbO2","readMoreMarker.module.eab1fb9e.js","k2CPQ","swiper1.module.d2d9279d.js","Hw6F8","swiper1.module.f9f6a655.js","aVFCZ","swiper2.module.f263507e.js","3TmCC","swiper3.module.6a31ab00.js","bnNTo","swiperTeam.module.f9d19e07.js","b3tdi","treatmentSearch.module.63fd8cc5.js","dbWMA","asVideo.module.b52d5ec9.js"]'));

// =============================================================
// IMPORTS
// =============================================================

(parcelRequire("8JF4K")).then(function(module) {
    module.init();
});

// =============================================================
// MODULES
// - Lazy loaded modules which are imported when needed
// =============================================================
if (document.querySelector(".flyout-menu")) (parcelRequire("lijxe")).then(function(module) {
    module.init();
});

if (document.querySelector(".header")) (parcelRequire("5uX6c")).then(function(module) {
    module.init();
});

if (document.querySelector(".lightbox")) (parcelRequire("8m52L")).then(function(module) {
    module.init();
});

if (document.querySelector(".modal")) (parcelRequire("IJ08D")).then(function(module) {
    module.init();
});

if (document.querySelector(".panel")) (parcelRequire("bvWYn")).then(function(module) {
    module.init();
});

if (document.getElementById("stickyButton")) (parcelRequire("bBnUP")).then(function(module) {
    module.init();
});

if (document.querySelector(".read-more-marker")) (parcelRequire("lyXDL")).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--1")) (parcelRequire("lX62M")).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--2")) (parcelRequire("kUVQA")).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--3")) (parcelRequire("gPrLj")).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container.swiper-team")) (parcelRequire("2T9xQ")).then(function(module) {
    module.init();
});

if (document.querySelector(".ctype-ce_treatment_search")) (parcelRequire("dn7Fz")).then(function(module) {
    module.init();
});

if (document.querySelector(".js-player")) (parcelRequire("dpdnY")).then(function(module) {
    module.init();
});
 // =============================================================
 // OTHER
 // =============================================================
 // const updateHeaderHeight = () => {
 //   let headerHeight = document.querySelector("header").offsetHeight;
 //   document.querySelector("main").style.marginTop = headerHeight + "px";
 // };
 // updateHeaderHeight();
 // =============================================================
 // WHEN COMPLETE
 // functions which are called when the page is fully loaded
 // =============================================================
 // let attempts = 0;
 // const whenComplete = () => {
 //   if (++attempts > 30) return;
 //   if (document.readyState === "complete") {
 //     window.addEventListener("resize", function (e) {
 //       updateHeaderHeight();
 //     });
 //   } else {
 //     setTimeout(() => whenComplete(), 400);
 //   }
 // };
 // whenComplete();
 // =============================================================
 // STYLES COMPLETE
 // Removes styles_essential when general styles are loaded
 // =============================================================
 // let styleAttempts = 0;
 // const stylesComplete = () => {
 //   if (++styleAttempts > 30) return;
 //   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
 //     document.querySelector("#sess").remove();
 //   } else {
 //     setTimeout(() => stylesComplete(), 300);
 //   }
 // };
 // stylesComplete();

})();
//# sourceMappingURL=as-legacy.js.map
